import React from 'react'
import './../index.scss'
import { getColorByStatus } from '../config/table'
import { useTranslation } from 'react-i18next'

function Status({ value }) {
  const { t } = useTranslation('ExtraOutput')
  return <div style={{ color: getColorByStatus(value) }}>{t(`${value}`)}</div>
}

export default Status
